import { ChoicesAnswer, MappedAnswer, ValueAnswer } from '../components/context/SurveyPageContext';
import Survey from '../interfaces/survey';
import { collectChooseManyAnswerIds } from './collectChooseManyAnswerIds';
import { collectChooseManyQuestions } from './collectChooseManyQuestions';

interface CollectCancelReasonsProps {
  mappedAnswers: Map<number, MappedAnswer>;
  survey: Survey | undefined;
}

interface AllReasonsProps {
  question?: string;
  reasons?: string[];
}

export interface CancelReasonsProps {
  improveService?: string;
  cancelReason?: string;
  allReasons?: AllReasonsProps[];
}

const collectCancelReasons = ({
  mappedAnswers,
  survey,
}: CollectCancelReasonsProps): CancelReasonsProps => {
  if (!survey) return {};
  const answeredQuestionIds = Array.from(mappedAnswers.keys());
  const choiceAnswers = Array.from(mappedAnswers.values()) as ChoicesAnswer[];
  const choiceIds = collectChooseManyAnswerIds({ choiceAnswers });
  const questions = collectChooseManyQuestions({ survey, questionIds: answeredQuestionIds });
  const cancelReasons: AllReasonsProps[] = [];
  const properties: CancelReasonsProps = {};

  questions.forEach((question) => {
    const choices = question.choices.filter((choice) => choiceIds.includes(choice.id));
    const choiceValues: string[] = choices
      .map((choice) => {
        const valueAnswer = mappedAnswers.get(question.id) as ValueAnswer;
        if (choice.value === 'Other' && valueAnswer.value) return valueAnswer.value;
        return choice.value;
      })
      .filter((value): value is string => !!value);
    switch (question.value) {
      case 'Why Are You Considering Cancelling Your Subscription?':
        properties.improveService = choiceValues.join(';');
        cancelReasons.push({ question: question.value, reasons: choiceValues });
        break;
      case 'How Can We Improve Our Service?':
        properties.cancelReason = choiceValues.join(';');
        cancelReasons.push({ question: question.value, reasons: choiceValues });
        break;
      default:
        cancelReasons.push({ question: question.value, reasons: choiceValues });
        break;
    }
  });
  if (cancelReasons.length > 0) {
    properties.allReasons = cancelReasons;
    return properties;
  }
  return {};
};

export { collectCancelReasons };
